import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

const requireRouter = require.context('.', false, /^(?!\.\/index).*\.js$/)
let _routers = []

requireRouter.keys().forEach(fileName => {
  // if (fileName === './index.js' || fileName === './routers.js') return
  _routers = [..._routers, ...requireRouter(fileName).default]
})

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'layout',
      component: () => import('@/views/layout'),
      children: _routers
    }, {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login')
    }
  ]
})

// router.beforeEach((to, from, next) => {
//   console.log(to.path)
//   if (to.path === '/') {
//     next({
//       path: '/login',
//       query: {}
//     })
//   } else {
//     next()
//   }
// })

export default router



// WEBPACK FOOTER //
// ./src/router/index.js